import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../../../Translations';
import { ImportedParticipantsResource } from '../../Store/Types';
import AddToGroup from './AddToGroup';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
}

function Footer({ successfulParticipantsResource }: Props) {
  return (
    <div className="action-block mx-auto mt-12 text-center">
      <AddToGroup successfulParticipantsResource={successfulParticipantsResource} />
      <NavLink to={'/people'} className="block text-center text-sm font-semibold text-teal-600">
        <T kind="Back to all people" />
      </NavLink>
    </div>
  );
}

export default observer(Footer);
